<template>
<!-- Start Wrapper Main -->
<div class="wrapper__main">
  <!-- Start Heading page -->
  <div class="heading-page">
    <div class="menu-title">
      <div class="container">
        <div class="menu-items row">
          <div class="col-xs-12">
            <ul>
              <li>
                <router-link to="/"> Home</router-link> <span>› </span>
              </li>
              <li><strong>Signup</strong></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="page-title">
      <h2>Create an Account</h2>
    </div>
  </div>
  <!-- End Heading page -->

  <!-- Start Account Section -->
  <section class="login my-4">
    <div class="container">
      <div class="row my-3">
        <div class="col-md-6">
          <div class="left-side p-4 ">
            <h5>NEW CUSTOMERS
                        </h5>
            <p>
              By creating an account with our store, you will be able to move through the checkout process faster, store multiple shipping addresses, view and track your orders in your account and more.
            </p>
            <div class="buttons-set">
              <router-link class="btn btn-larg btn-primary m-1" to="/login">
                <i class="fa fa-sign-in" aria-hidden="true"></i>
                <span class="px-2">Login</span>
              </router-link>
            </div>
          </div>
        </div>
        <!--part login-->
        <div class="col-md-6">
          <div class="r-side  p-4">
            <h5>REGISTERED CUSTOMERS</h5>
            <p>If you have an account with us, please log in.</p>
            <div v-if="errors" class="col-md-12">
              <ResponseError v-for="(err, i) in errors" :key="i" :err="err[0]" />
            </div>
            <form @submit.prevent="Signup">
              <div class="form-group">
                <label for="name">name</label>
                <input type="text" required v-model="user.name" class="form-control" id="name">

              </div>
              <div class="form-group">
                <label for="email">email</label>
                <input type="text" required v-model="user.email" class="form-control" id="email" aria-describedby="emailHelp">

              </div>
              <div class="form-group">
                <label for="mobile">moblie </label>
                <input type="text" required v-model="user.mobile" class="form-control" id="mobile">
                <!-- <p style="color: red;">* Required Fields

                </p> -->

              </div>
              <div class="form-group">
                <label for="address">Address</label>
                <input type="text" required v-model="user.address" class="form-control" id="address" />

              </div>
              <!-- <p style="color: red;">* Required Fields

              </p> -->
              <div class="password">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="password">password </label>
                      <input type="password" required v-model="user.password" class="form-control" id="password" aria-describedby="passwordHelp">

                    </div>
                  </div>
                  <div class="col-md-6">

                    <div class="form-group">
                      <label for="passwordconf">confirm password </label>
                      <input type="password" required v-model="user.password_confirmation" class="form-control" id="passwordconf" aria-describedby="passwordconfHelp">

                    </div>
                  </div>

                </div>
              </div>
              <div class="form-group">
               <label for="exampleFormControlFile1">Upload your image</label>
               <input type="file" ref="pic" @change="handleUploadFile" accept="image/*" class="form-control-file" id="exampleFormControlFile1">
              </div>
              <button ref="btn" type="submit" class=""><span>Create an Account</span></button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Account Section -->
</div>
<!-- End Wrapper Main -->
</template>
<script>
import ResponseError from '@/components/assets/ResponseError'
  export default{
    data(){
      return{
        user:{},
        submitting: false,
        errors:''
      }
    },
    components:{
      ResponseError
    },
    computed:{
      api() {
        return this.$store.state.api
      }
    },
    methods:{
      handleUploadFile() {
        this.user.photo = this.$refs.pic.files[0];
      },
      Signup() {
        this.submitting = true;
        this.$refs.btn.setAttribute('disabled', true);
        let formData = new FormData();
        formData.append('name', this.user.name);
        formData.append('email', this.user.email);
        formData.append('mobile', this.user.mobile);
        formData.append('address', this.user.address);
        formData.append('password', this.user.password);
        formData.append('password_confirmation', this.user.password_confirmation);
        formData.append('photo', this.user.photo);
        fetch(`${this.api}/client/register`, {
            method: 'POST',
            // headers:{
            //   "Content-Type": "application/json"
            // },
            mimeType: 'multipart/form-data',
            body: formData
          })
          .then(res => res.json())
          .then(data => {
            this.submitting = false;
            this.$refs.btn.removeAttribute('disabled');

            if(data.success){
              localStorage.setItem('care_user_auth_token', 'Bearer ' + data.data.token);
              localStorage.setItem('care_user_id', data.data.id);
              localStorage.setItem('care_user_name', data.data.name);
              this.$router.history.push('/');
            } else{
              this.errors = data.data;
             }
          })
          .catch(err => {
            alert('An error happend');
            this.submitting = false;
            this.$refs.btn.removeAttribute('disabled');
          })
        }
    }
  }
</script>
<style media="screen">
body{

    background-color: #f7f9fe;

  }



  /*sec1 code start*/

  .sec1{
    /* background-image: url("../images/login_background.jpg"); */
    background-size: cover;
    background-position: center center;


  }
  .cap-sect1-login{
    display: flex;
    width: 100%;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 20px;
  margin-bottom: 20px;
  }
  /*sec1 code end*/

  .sec1 h2{
    padding-bottom: 20px;

    color: #fff;
    font-family: 'Oswald', sans-serif;
      font-size: 42px;
      font-weight: 500;
      text-transform: uppercase;
      margin-top: 0px;
      padding: 0px 25px;
      margin: 0px;
      display: inline-block;
      margin-top: 5px;
      letter-spacing: 1px
  }


  /******************/
  /*regatsiter side*/
  .left-side{
  background-color: #fff
  ;
  }
  .button{
    background: #2a81ea;
      color: #fff;
      padding: 8px;
      border-radius: 20px;
  }

  .button span{
    font-weight: 500;
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
  }
  .button::before{
    content: "\f007";
    font-family: "Font Awesome 5 Free";
      font-size: 12px;
      padding-right: 8px;
  }
  /*login part*/
  .r-side{
  background-color: #fff;



  }
  .button1{
    display: inline-block;
      background-color: #efecec;
      font-size: 13px;
      text-align: center;
      white-space: nowrap;
      font-weight: 500;
      border: none;
      border-radius: 999px;
      letter-spacing: 0.5px;
      padding: 12px 20px 10px 20px;
      font-family: 'Barlow', sans-serif;
  }.button1 span{
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .button1::before{
    content: "\f007";
         font-family: "Font Awesome 5 Free";
         font-size: 12px;
         padding-right: 8px;

  }
  .button1 a{
      text-decoration: none;

  }
  .create-account a{
    text-decoration: none;

}

</style>
